import { api } from "../../src/component/constent";


// ============================================================
// CURRENT MONTH
// ============================================================

export const getFreightAndProformaCurrentMonth = () => {

    return api.get(
        "/entry/current-month"
    );

};


// ============================================================
// GET DATA
// ============================================================

export const getFreightAndProformaOnCost = (
    month,
    year
) => {

    return api.get(
        "/entry/freightandproformaoncost",
        {
            params: {
                month,
                year
            }
        }
    );

};


// ============================================================
// SAVE DATA
// ============================================================

export const saveFreightAndProformaOnCost = (
    data
) => {

    return api.post(
        "/entry/freightandproformaoncost",
        data
    );

};


// ============================================================
// DELETE DATA
// ============================================================

export const deleteFreightAndProformaOnCost = (
    month,
    year
) => {

    return api.delete(
        "/entry/freightandproformaoncost",
        {
            params: {
                month,
                year
            }
        }
    );

};